import React from 'react';
import cn from 'classnames';

import Button from '@Components/Button';
import {
  PLACEMENT_BOTTOM,
  PLACEMENT_RIGHT,
  PLACEMENT_MODAL,
} from '../constants';

import './ConditionsPlacementControl.scss';

const ConditionsPlacementControl = ({ placement, setPlacement, setIsShown }) => {
  const getDockButtonClassName = (pls) => {
    return cn(
      'project-route-conditions-placement-control__button',
      'project-route-conditions-placement-control__button--dock',
      { 'current': placement === pls });
  }
  const dockIconClassName = 'project-route-conditions-placement-control__button--dock__icon';
  const closeButtonClassName = cn(
    'project-route-conditions-placement-control__button',
    'project-route-conditions-placement-control__button--close',
  );

  return (
    <div className="project-route-conditions-placement-control rx-flex-0 rx-flex-row-container">
      <Button
        onClick={() => setPlacement(PLACEMENT_MODAL)}
        buttonConfig={{
          type: 'link',
          size: 'sm',
          className: getDockButtonClassName(PLACEMENT_MODAL),
          e2eName: 'conditions-open-in-modal',
          ariaLabel: 'Undocked',
          title: 'Open in modal',
        }}
        iconConfig={{
          name: 'undocked',
          className: dockIconClassName,
        }}
      />
      <Button
        onClick={() => setPlacement(PLACEMENT_BOTTOM)}
        buttonConfig={{
          type: 'link',
          size: 'sm',
          className: getDockButtonClassName(PLACEMENT_BOTTOM),
          e2eName: 'conditions-dock-bottom',
          ariaLabel: 'Docked bottom',
          title: 'Dock bottom',
        }}
        iconConfig={{
          name: 'docked-bottom',
          className: dockIconClassName,
        }}
      />
      <Button
        onClick={() => setPlacement(PLACEMENT_RIGHT)}
        buttonConfig={{
          type: 'link',
          size: 'sm',
          className: getDockButtonClassName(PLACEMENT_RIGHT),
          e2eName: 'conditions-dock-right',
          ariaLabel: 'Docked right',
          title: 'Dock right',
        }}
        iconConfig={{
          name: 'docked-right',
          className: dockIconClassName,
        }}
      />
      <span className="project-route-conditions-placement-control__divider"></span>
      <Button
        buttonConfig={{
          type: 'link',
          size: 'sm',
          className: closeButtonClassName,
          ariaLabel: 'Close conditions',
          e2eName: 'modal-close',
        }}
        iconConfig={{ name: 'delete', size: 'tiny' }}
        onClick={() => setIsShown(false)}
      />
    </div>
  );
};

export default ConditionsPlacementControl;
